"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _echarts = _interopRequireDefault(require("echarts"));

var _dvaNoRouter = require("dva-no-router");

var _utils = _interopRequireDefault(require("../../utils/utils"));

var _dec, _class, _temp;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Bar = (_dec = (0, _dvaNoRouter.connect)(function (_ref) {
  var global = _ref.global,
      rest = _objectWithoutProperties(_ref, ["global"]);

  return _objectSpread({}, global, {
    rest: rest
  });
}), _dec(_class = (_temp =
/*#__PURE__*/
function (_Component) {
  _inherits(Bar, _Component);

  function Bar() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Bar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Bar)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleEchartsProps", function (props) {
      var echartsId = props.echartsId,
          title = props.title,
          typeProps = props.typeProps,
          _props$axisProps = props.axisProps,
          axisProps = _props$axisProps === void 0 ? {
        type: 'x'
      } : _props$axisProps,
          dataSource = props.dataSource,
          grid = props.grid,
          xAxis = props.xAxis,
          yAxis = props.yAxis,
          selfProps = props.selfProps;
      _this.myChart = _echarts.default.init(document.getElementById(echartsId));
      var tempDataSource = [];
      dataSource.forEach(function (item, index) {
        if (index < 10) {
          tempDataSource.push(item);
        }
      });
      var axisType = axisProps.type,
          axisName = axisProps.name,
          label = axisProps.label;

      var option = _objectSpread({
        title: title,
        grid: _objectSpread({
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        }, grid),
        xAxis: _objectSpread({
          type: axisType === 'y' ? 'value' : 'category',
          name: axisName && axisName.x || null,
          triggerEvent: true,
          axisLine: {
            lineStyle: {
              color: '#BCBCBC'
            }
          },
          splitLine: {
            lineStyle: {
              color: '#E9E9E9',
              type: 'dashed'
            }
          },
          axisLabel: {
            formatter: function formatter(value) {
              var valueTxt = '';

              if (value.length > 4 && dataSource.length > 5) {
                valueTxt = "".concat(value.substring(0, 4), "...");
              } else if (dataSource.length < 6 && value.length > 6) {
                valueTxt = "".concat(value.substring(0, 6), "...");
              } else {
                valueTxt = value;
              }

              return valueTxt;
            },
            interval: 0
          }
        }, xAxis),
        yAxis: _objectSpread({
          type: axisType === 'x' ? 'value' : 'category',
          name: axisName && axisName.y || null,
          triggerEvent: true,
          splitLine: {
            lineStyle: {
              color: '#E9E9E9',
              type: 'dashed'
            }
          },
          axisLine: {
            lineStyle: {
              color: '#BCBCBC'
            }
          },
          axisLabel: {
            formatter: function formatter(value) {
              var valueTxt = '';

              if (value.length > 10) {
                valueTxt = "".concat(value.substring(0, 10), "...");
              } else {
                valueTxt = value;
              }

              return valueTxt;
            }
          }
        }, yAxis),
        series: [_objectSpread({
          data: axisType === 'y' ? dataSource : tempDataSource,
          type: 'bar',
          barWidth: axisType === 'y' ? 20 : 24,
          label: label,
          color: '#1785EC'
        }, typeProps)]
      }, selfProps);

      _this.myChart.setOption(option);

      (0, _utils.default)(_this.myChart, axisType);
    });

    return _this;
  }

  _createClass(Bar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleEchartsProps(this.props);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.handleEchartsProps(nextProps);
    } // 处理图表属性

  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", null);
    }
  }]);

  return Bar;
}(_react.Component), _temp)) || _class);
var _default = Bar;
exports.default = _default;